import { AbstractControl, ValidationErrors, ValidatorFn, FormArray } from '@angular/forms'

export const atLeastOneResponseValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const formArray = control as FormArray
    const hasAtLeastOne = formArray.controls.some(c => c.value && c.value.trim() !== '')
    return hasAtLeastOne ? null : { atLeastOneRequired: true }
}
